import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Mail, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/password-reset/request", { username }); }
    catch {}
    setSent(true); setBusy(false);
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="emmepi-logo-mark">M</div>
          <div>
            <div className="text-lg font-extrabold text-slate-900">emmepigroup</div>
            <div className="text-xs text-slate-500 uppercase tracking-wider">Recupero password</div>
          </div>
        </div>
        {sent ? (
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-green-700 bg-green-50 border border-green-200 rounded p-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
              <div className="text-sm">Se l'account esiste, riceverai a breve una email con le istruzioni. Il link è valido 30 minuti.</div>
            </div>
            <Link to="/login" className="text-sm text-blue-700 hover:underline inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Torna al login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h1 className="text-2xl font-bold text-slate-900 mb-1">Password dimenticata?</h1>
            <p className="text-sm text-slate-600">Inserisci la tua email aziendale. Ti invieremo un link temporaneo per reimpostare la password.</p>
            <div>
              <Label>Email</Label>
              <Input type="email" required autoFocus value={username} onChange={e => setUsername(e.target.value)} data-testid="forgot-username" />
            </div>
            <Button type="submit" disabled={busy || !username} className="w-full bg-blue-700 hover:bg-blue-800" data-testid="forgot-submit">
              {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />} Invia link di reset
            </Button>
            <Link to="/login" className="block text-center text-sm text-slate-500 hover:text-slate-800"><ArrowLeft className="w-3 h-3 inline mr-1" /> Torna al login</Link>
          </form>
        )}
      </Card>
    </div>
  );
}
